import * as React from 'react';
import styled from 'styled-components';

const MarginIcon = styled.span`
    position: relative;
    display: inline-block;
    font-size: 12px;
    font-size: ${({ lg }) => lg ? '16px' : '12px'};
    border-radius: 3px;
    width: 14px;
    height: 14px;
    line-height: ${({ lg }) => lg ? '' : '12px'};
    text-align: center;
    color: ${({ theme, unselected }) => unselected ? theme.fontColor : theme.highlight};
    border: ${({ theme, noborder }) => noborder ? 'none' : `solid 1px ${theme.activeBorder}`};
`;
export default props => (
  <MarginIcon {...props}>M</MarginIcon>
);
